import utils from './utils';
class Tenant {
  private idKey = 'HRTPS_PRODUCTS_ADMIN_TENANT_ID';
  private store: any = window.localStorage;
  constructor() {
    const tenantId = utils.getQueryByName('tenantId');
    if (tenantId) {
      this.setTenantId(tenantId);
    }
  }
  getTenantId() {
    let tid = this.store && this.store.getItem(this.idKey);
    if (process.env.NODE_ENV === 'development' && !tid) {
      return '1000000008';
    }
    if (!tid) {
      const tenantId = utils.getQueryByName('tenantId');
      tenantId && this.setTenantId(tenantId);
      tid = tenantId;
    }
    return tid || '';
  }
  setTenantId(id: string) {
    this.store && this.store.setItem(this.idKey, id);
  }
  removeTenantId() {
    this.store && this.store.removeItem(this.idKey);
  }
}
export default new Tenant();
